import { lazy } from 'react';

const AccountInformationPage = lazy(() => import('./AccountConfirmationPage'));

const AccountConfirmationConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: null,
  routes: [
    {
      path: 'account-confirm',
      element: <AccountInformationPage />,
    },
  ],
};

export default AccountConfirmationConfig;
